<app-banner [banner]="passwordResetPage.banner"></app-banner>
<div id="container" class="container-fluid minHeight">
  <div class="container">
    <form [formGroup]="resetPasswordForm" (Submit)="OnPasswordRestFormSubmit()">
      <div class="row">
        <div class="col-sm-9 offset-md-3 login-container commonFormsCss">
          <div id="loginbox" class="main-login-box">
            <div class="row">
              <div class="col-sm-12 sign-in-heading">
                <h3>Password Reset</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-7">
                <section id="resetPasswordForm">
                  <div class="row">
                    <div class="sm-offset-1 col-sm-11">
                      <div class="brd">
                        <div class="form-group login-form">
                          <div class="row">
                            <div class="col-sm-12 pl-5 pr-5 mb-2 mt-3">
                              <span class="control-label">eMail</span><br />

                              <input type="text" formControlName="email" [disabled]="true" class="form-control form-control-sm" />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12 pl-5 pr-5 mb-3 mt-3">
                              <span class="control-label">Password</span><br />

                              <input type="password" formControlName="password" class="form-control form-control-sm" />

                              <div class="field-validation-valid text-danger" *ngIf="submitPassword && f['password'].errors && f['password'].errors['required']">Please enter a valid password .</div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12 pl-5 pr-5">
                              <span class="control-label">Confirm Password</span><br />
                              <input type="password" formControlName="confirmPassword" class="form-control form-control-sm" />

                              <div class="field-validation-valid text-danger" *ngIf=" f['confirmPassword'].errors?.['confirmedValidator']">The password and confirmation password do not match</div>
                              <div class="field-validation-valid password-instruction-text">
                                Passwords must be between 8 and 20 characters long and include a mix of letters (English A-Z) and numbers with no spaces. You can include one of the following special
                                characters: ! " # $ ' ( ) * + , - . / : ; < = > ? &#64; [ ^ ] _ ` {{ '{' }} | {{ '}' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="md-offset-3 col-md-11">
                      <button role="button" type="button" (click)="OnPasswordRestFormSubmit()" class="ba-btn btn-thin pull-right">Reset</button>
                    </div>

                    <input type="hidden" id="returnUrl" name="returnUrl" value="/" />
                  </div>
                </section>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
